import React, { createContext, useContext, useEffect, useState } from "react";
import { ui } from "@/i18n/translations";

const LanguageContext = createContext({
  lang: "en",
  setLang: () => {},
  t: ui.en,
});

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "en";
    const stored = window.localStorage.getItem("rota-lang");
    // TR is temporarily disabled — fall through to EN even if stored.
    if (stored === "en" || stored === "ru") return stored;
    const browser = (navigator.language || "en").toLowerCase();
    if (browser.startsWith("ru")) return "ru";
    return "en";
  });

  const setLang = (newLang) => {
    setLangState(newLang);
    try {
      window.localStorage.setItem("rota-lang", newLang);
    } catch (e) {
      // ignore
    }
  };

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const value = {
    lang,
    setLang,
    t: ui[lang] || ui.en,
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
